// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.empty-card-pp img[data-v-341da86f] {\n  width: var(--341da86f-iconSize);\n}\n.empty-card-pp h6[data-v-341da86f] {\n  color: var(--green);\n  font-size: 0.9rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
